export default {
    formBankStatementLoading: false,
    formBankStatement: {
        account_id: null,
        year_month: null,
        file: null
    },
    formBankConciliation: {
        account_id: null,
        year_month: null,
        state: "pendientes",
        optionsGenerate: ["value", "date"],
        delete_items: null
    },
    accounts: [],
    formBankStatementResponse: {},
    dataBankConciliation: {
        bankConcilOper: [],
        documentTransactions: []
    },
    dataBankConciliationLoading: false,
    bankConciliationOperTransactions: {
        informationExtract: [],
        accountingInformation: []
    },
    bankConciliationTransactionsDetail: false,
    bankConciliationStatus: null,
    dataBankConciliationTransactions: {
        bankConcilOper: [],
        documentTransactions: []
    },
    generateBankConciliationResponse: null,
    bankReconciliationReport: {
        form: {
            description: ""
        }
    },
    bankReconciliationReportResponse: {},
    auxiliary_accounts: [],
    voucherPayload: {
        branchoffice_id: null,
        voucherType_id: null,
        no_doc: null,
        prefix: null,
        date: "",
        contact_id: null,
        observation: "GASTOS FINANCIEROS",
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            observation: "GASTOS FINANCIEROS",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        ids_conciliation: [],
        modal_loading: false
    },

    show_pdf: false,
    file_name: null
};



// WEBPACK FOOTER //
// ./src/modules/incorporate-bank-statement/state.js